import React from 'react';
import { ArrowUpDown } from 'lucide-react';

/**
 * SortDropdown - Sort options for vehicle results
 * Provides sorting by popularity, date, mileage, etc.
 */
const SortDropdown = ({ sortBy, onSortChange }) => {
  const sortOptions = [
    { value: 'popular', label: 'Best Match' },
    { value: 'newest', label: 'Newest First' },
    { value: 'mileage', label: 'Lowest Mileage' },
    { value: 'price_asc', label: 'Price: Low to High' },
    { value: 'price_desc', label: 'Price: High to Low' },
  ];

  return (
    <div className="flex items-center gap-2">
      <ArrowUpDown className="w-4 h-4 text-app-text-secondary-light dark:text-app-text-secondary" />
      <label className="text-sm font-medium text-app-text-light dark:text-app-text">
        Sort by:
      </label>
      <select
        value={sortBy}
        onChange={(e) => onSortChange(e.target.value)}
        className="px-3 py-2 rounded-xl bg-app-bg-secondary-light dark:bg-app-bg-secondary text-app-text-light dark:text-app-text border border-app-border-light dark:border-app-border focus:outline-none focus:ring-2 focus:ring-app-accent text-sm font-medium cursor-pointer"
      >
        {sortOptions.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SortDropdown;
